import { combineReducers } from "redux";
import notificationReducer from './notificationReducer';
import langReducer from './langReducer';
import navBarReducer from './navBarReducer';
import envReducer from './envReducer';
import topBannerReducer from './topBannerReducer';
import homeSectionReducer from './homeSectionReducer';
import searchReducer from "./searchReducer";
import blogReducer from "./blogReducer";
import activityReducer from "./activityReducer";

const rootReducer = combineReducers({
    notification: notificationReducer,
    language: langReducer,
    navBar: navBarReducer,
    envReducer: envReducer,
    topBanner: topBannerReducer,
    homeSection: homeSectionReducer,
    globalSearch: searchReducer,
    blog: blogReducer,
    activity: activityReducer,

})
export default rootReducer;